import { Button, CloseButton, Dialog, Portal } from "@chakra-ui/react";
import { Field } from "../ui/field";
import { useState } from "react";
import { useDispatch } from "react-redux";
import { PasswordInput } from "../ui/password-input";
import { changeUserPassword } from "../../Redux/Action";

export const PasswordChangeModal = ({ isOpen, onClose, data, refetchData }) => {
  const dispatch = useDispatch();
  const [formData, setFormData] = useState({ adminPass: "", newPass: "", confirmPass: "" });
  const [errors, setErrors] = useState({ adminPass: "", newPass: "", confirmPass: "" });
  const [isDisabled, setIsDisabled] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
    setErrors((prev) => ({ ...prev, [name]: "" }));
  };
  const handleSubmit = () => {
    const { adminPass, newPass, confirmPass } = formData;
    let hasError = false;
    if (!adminPass) {
      setErrors((prev) => ({ ...prev, adminPass: "admin password is required" }));
      hasError = true;
    }
    if (newPass !== confirmPass) {
      setErrors((prev) => ({ ...prev, confirmPass: "Password is not matching." }));
      hasError = true;
    }


    if (!hasError) {
      setIsDisabled(true);
      dispatch(
        changeUserPassword({
          adminPass,
          newPass,
          userId: data?._id,
          callback: (data) => {
            if (data?.meta?.code === 200) {
              onClose();
              refetchData();
            }
            setIsDisabled(false);
          },
        })
      );
    }
  };

  return (
    <Dialog.Root lazyMount open={isOpen}>
  
      <Portal>
        <Dialog.Backdrop />
        <Dialog.Positioner>
          <Dialog.Content>
            <Dialog.Header>
              <Dialog.Title>Change Password</Dialog.Title>
            </Dialog.Header>
            <Dialog.Body>
              <Field label="Admin Password" invalid={!!errors?.adminPass} errorText={errors?.adminPass}>
                <PasswordInput name="adminPass" value={formData?.adminPass} onChange={handleChange} />
              </Field>
              <Field label="New Password" invalid={!!errors?.newPass} errorText={errors?.newPass}>
                <PasswordInput name="newPass" value={formData?.newPass} onChange={handleChange} />
              </Field>
              <Field label="Confirm Password" invalid={!!errors?.confirmPass} errorText={errors?.confirmPass}>
                <PasswordInput name="confirmPass" value={formData?.confirmPass} onChange={handleChange} />
              </Field>
            </Dialog.Body>
            <Dialog.Footer>
              <Button variant="outline" onClick={onClose}>
                Cancel
              </Button>
              <Button onClick={handleSubmit} disabled={isDisabled}>
                Save
              </Button>
            </Dialog.Footer>
          </Dialog.Content>
        </Dialog.Positioner>
      </Portal>
    </Dialog.Root>
  );
};
